module.exports = __webpack_public_path__ + "img/icon_inventario_padres_hover.e18cdf7f.svg";